/**
 * Thread / chat PlotCard title: the marketer-facing question stem only.
 *
 * Payload already carries `question.display_title` (python `question_display_fields`).
 * Versions, choice lists, and scorecard dimensions belong on the chart — never in the
 * bold header. Rating scale anchors go in the muted subtitle via `plotQuestionScale`.
 */

export interface PlotQuestionHeaderSource {
  title?: string
  construct_title?: string
  question?: {
    display_title?: string
    dimension_labels?: Array<string>
    minRateDescription?: string
    maxRateDescription?: string
    rateMin?: number
    rateMax?: number
    choices?: Array<string | { text?: string; label?: string }>
  } | null
}

function questionStem(result: PlotQuestionHeaderSource): string {
  return (
    (result.question?.display_title || '').trim() ||
    (result.construct_title || '').trim() ||
    (result.title || '').trim()
  )
}

/** Rating scale anchors only — never versions, choices, or dimension lists. */
export function plotQuestionScale(result: PlotQuestionHeaderSource): string {
  const question = result.question
  if (!question) {
    return ''
  }

  const minDesc = (question.minRateDescription || '').trim()
  const maxDesc = (question.maxRateDescription || '').trim()
  const hasRange =
    typeof question.rateMin === 'number' && typeof question.rateMax === 'number'
  const range = hasRange ? `${question.rateMin}-${question.rateMax}` : ''

  if (minDesc || maxDesc) {
    const ends =
      minDesc && maxDesc ? `${minDesc} → ${maxDesc}` : minDesc || maxDesc
    return range ? `${range} ${ends}` : ends
  }

  return range
}

export function plotQuestionHeader(result: PlotQuestionHeaderSource): string {
  return questionStem(result)
}
